var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modalCounting)?_c('div',{ref:"modal-count",attrs:{"id":"modal-count"}},[_c('div',{staticClass:"background-counting"},[_c('h1',[_vm._v("Time: "+_vm._s(_vm.timeout))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }